import React from "react";
import { Button, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";
import { AdminActions } from "../../actions/adminActions";
import { ServerActions } from "../../actions/serverActions";
import Constants from "../../constants/constants";
import { adminStore } from "../../stores/adminStore";
import { subdivisionStore } from "../../stores/subdivision";
import { ContentBox } from "./ContentBox";

import "../../css/adminScreen.css";
import { formConversion } from "../../util/formConversion";
import { withRouter } from "../../util/withRouter";
var successMsg = "";

// Load state from the stores
function getStateFromStores() {
  return {
    itemType: adminStore.getItemType(),
    isLoading: adminStore.isLoading(),
    items: adminStore.getItems(),
    loadingError: adminStore.getError(),
    subdivisions: subdivisionStore.getEntireSubList(),
    disableHeader: false,
    rowCount: 10,
    scrollToIndex: undefined,
    height: 325,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
    hideIndexRow: false,
    sortBy: "name",
    sortDirection: SortDirection.ASC,
    filteredData: adminStore.getItems(),
    patternTexts: [],
    defaultID: 0,
    oldIsAdmin: false,
    alertVisible: false,
    alertMessage: "",
    defaultChecked: true,
    data: adminStore.getItems(),
    isCreateEdit: false,
    isCreate: false,
    patternIdText: "",
    patternIdTextChanged: false,
    currentPatternId: "",
    errorMessage: [],
    patternDescriptionText: "",
    patternDescriptionTextChanged: false,
  };
}

class PatternMaintenanceComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = getStateFromStores();
  }

  componentDidMount() {
    adminStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    AdminActions.setItemType(this.props.location.pathname);
    AdminActions.loadItems();
    ServerActions.getSubdivisionList();
  }

  componentWillUnmount() {
    adminStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
  }

  _onChange = () => {
    this.setState(getStateFromStores());
  };

  _rowClassName = ({ index }) => {
    if (index < 0) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  };

  _noRowsRenderer = () => (
    <div className="issuedNoRows">
      {this.state.isLoading ? "Loading..." : "No rows found"}
    </div>
  );

  _getDatum = (list, index) => {
    return list.get(index % list.size);
  };

  _sort = ({ sortBy, sortDirection }) => {
    const comparer = (a, b) => {
      if (sortDirection === "ASC") {
        return a[sortBy] > b[sortBy] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortBy] < b[sortBy] ? 1 : -1;
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.state.originalRows.slice(0)
        : this.state.filteredData.sort(comparer);

    this.setState({ rows });
    this.setState({ sortBy, sortDirection });
  };

  _onRowClick = (data) => {
    var patternTexts = data.rowData.restrictionPatternLines;

    var restrPatternLinesMap = sortAndReturnPatternTexts(patternTexts);

    this.setState({
      isCreate: true,
      patternIdText: data.rowData.restrictionPatternDescription,
      patternDescriptionText: restrPatternLinesMap.join("\n"),
      isCreateEdit: false,
      currentPatternId: data.rowData.id,
      patternTexts: patternTexts,
    });
  };

  formatValue = ({ dataKey, rowData }) => {
    if (dataKey === "restrictionPatternDescription") {
      return renderDataWithPopover(
        rowData.restrictionPatternDescription,
        rowData.restrictionPatternLines
      );
    }
  };

  changePatternIdText(data) {
    this.setState({
      patternIdText: data,
      patternIdTextChanged: true,
    });
  }

  changePatternDescriptionText(e) {
    const cursorStart = e.target.selectionStart;

    const data = e.target.value || "";

    // Break up the entered text when the user hits enter
    // when a line is longer than the max length. 
    // chunkText also performs word wrapping
    let patternText = [];

    let wrappedLines = chunkText(
      data,
      Constants.MaxValues.MAX_PATTERN_LINE_LENGTH
    ); //chunk the lines into 62 char segments
    patternText = wrappedLines.split("\n");

    //Only keep the first 120 lines
    if (patternText.length > Constants.MaxValues.MAX_PATTERN_LINE_COUNT)
      patternText.splice(Constants.MaxValues.MAX_PATTERN_LINE_COUNT);

    const patternLineText = patternText.join("\n")

    this.setState(
      {
        patternDescriptionText: patternLineText,
        patternDescriptionTextChanged: true,
      },
      () => {
        if (this.$textarea.value != null) {
          this.$textarea.selectionEnd = cursorStart;
        }
      }
    );
  }

  createPattern = () => {
    this.setState({
      isCreate: true,
      isCreateEdit: true,
      patternIdText: "",
      patternDescriptionText: "",
      currentPatternId: "",
    });
  };

  cancelCreatePattern = () => {
    this.setState({ isCreate: false });
    successMsg = "";
  };

  deletePattern = () => {
    const { currentPatternId } = this.state;
    window
      .confirm("Confirm Delete", {
        description:
          "Selecting Delete Pattern will remove this Pattern for all Users. Are you sure you want to do this ?",
        confirmLabel: "Delete",
        abortLabel: "Go Back",
      })
      .then(() => {
        AdminActions.deletePatternMaint(currentPatternId)
          .done(() => {
            AdminActions.loadItems();
            successMsg = (
              <label className="informationRequestInfoItem">
                Pattern Code {currentPatternId} deleted successfully{" "}
              </label>
            );
          })
          .fail((error) => {
            console.log("Something went wrong..");
            console.log(error);
            successMsg = (
              <label className="informationRadiatorErrorItem">
                Failed to Delete pattern
              </label>
            );
          });
      });
  };

  handleAlertDismiss = () => {
    this.setState({ alertVisible: false });
  };

  savePattern = () => {
    const {
      currentPatternId,
      patternIdText,
      patternDescriptionText,
      isCreateEdit,
    } = this.state;
    if (
      patternIdText.trim().length > 0 &&
      patternDescriptionText.trim().length > 0
    ) {
      const descLine = patternDescriptionText
        .split("\n")
        .map((lineText, index) => ({ seqNo: index + 1, lineText }));

      const requiredObj = {
        id: currentPatternId,
        restrictionPatternDescription: patternIdText,
        restrictionPatternLines: descLine,
      };

      if (!isCreateEdit) {
        window
          .confirm("Confirm Update", {
            description:
              "Selecting Update will overwrite the previous Pattern and save current work. Are you sure you want to do this ?",
            confirmLabel: "Update",
            abortLabel: "Go Back",
          })
          .then(() => {
            const recID = currentPatternId.toString().toUpperCase();
            AdminActions.updateNewPatternMaint(requiredObj)
              .done(() => {
                AdminActions.loadItems();
                successMsg = (
                  <label className="informationRequestInfoItem">
                    Pattern Code {recID} updated successfully
                  </label>
                );
              })
              .fail(() => {
                successMsg = (
                  <label className="informationRadiatorErrorItem">
                    Failed to update pattern
                  </label>
                );
              });
          });
      } else {
        AdminActions.submitNewPatternMaint(requiredObj)
          .done(() => {
            AdminActions.loadItems();
            successMsg = (
              <label className="informationRequestInfoItem">
                Pattern Code created successfully
              </label>
            );
          })
          .fail(() => {
            successMsg = (
              <label className="informationRadiatorErrorItem">
                Failed to create pattern
              </label>
            );
          });
      }
    } else {
      this.setState({
        alertVisible: true,
        alertMessage: "Please fill required information",
      });
    }
  };

  _filterRecordsOfTheTable = (value) => {
    var dataSet = this.state.items.filter((item) => {
      if (
        item.restrictionPatternDescription
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.id + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1
      ) {
        return true;
      }
    });
    this.setState({ filteredData: dataSet });
  };

  render() {
    var errorMsg = "";
    var searchBox = (
      <div id="accordion" className="ui-widget-TableHeader">
        {successMsg}
        <span>
          <b> Search: </b>
        </span>
        <input
          type="text"
          onChange={(event) =>
            this._filterRecordsOfTheTable(event.target.value)
          }
        />
      </div>
    );
    if (this.state.alertVisible) {
      errorMsg = (
        <Modal
          bsSize="large"
          dialogClassName="errorModal"
          onHide={this.handleAlertDismiss}
          show={this.state.alertVisible}
        >
          <Modal.Header closeButton>
            <Modal.Title>Error</Modal.Title>
          </Modal.Header>

          <div className="modal-body">{this.state.alertMessage}</div>
          <div className="modal-footer">
            <Button id="cancelConfirmButton" onClick={this.handleAlertDismiss}>
              OK
            </Button>
          </div>
        </Modal>
      );
    }

    var addButton = (
      <div className="float-right">
        <Button
          bsStyle="primary"
          className="adminButton"
          onClick={this.createPattern}
        >
          Create New Pattern
        </Button>
      </div>
    );
    var updateButton = (
      <div>
        <Button
          bsStyle="primary"
          className="adminButton"
          disabled={
            !(
              this.state.patternIdTextChanged ||
              this.state.patternDescriptionTextChanged
            )
          }
          onClick={this.savePattern}
        >
          {this.state.isCreateEdit ? "Save Pattern" : "Update Pattern"}
        </Button>

        {!this.state.isCreateEdit && (
          <div>
            <Button
              bsStyle="danger"
              className="adminButton"
              onClick={this.deletePattern}
            >
              Delete Pattern
            </Button>
          </div>
        )}
      </div>
    );
    var cancel = (
      <div>
        <Button
          bsStyle="warning"
          className="adminButton"
          onClick={this.cancelCreatePattern}
        >
          Cancel{" "}
        </Button>
      </div>
    );

    var content = "Loading....";

    if (this.state.isLoading) {
      content = "Loading....";
    } else {
      if (this.state.itemType == "/patternsMaintenance") {
        const {
          rowHeight,
          headerHeight,
          overscanRowCount,
          sortBy,
          sortDirection,
          currentPatternId,
          patternDescriptionText,
          filteredData,
        } = this.state;

        var createEdit = (
          <div className="row">
            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
              <label>
                {currentPatternId &&
                  "Pattern: " + String(currentPatternId).padStart(4, "0")}
              </label>
              <br />
              <label>Pattern Description:</label>
              <br />

              <input
                type="text"
                onChange={(event) =>
                  this.changePatternIdText(event.target.value)
                }
                value={this.state.patternIdText}
                id="patternDescription"
                className="mpInput"
                maxLength="60"
                style={{ width: "500px" }}
                required
              />
              <br />
              <label>Pattern Text:</label>
              <br />
              <textarea
                id="formCText"
                ref={(node) => (this.$textarea = node)}
                rows={20}
                cols={Constants.MaxValues.MAX_PATTERN_LINE_LENGTH}
                value={patternDescriptionText}
                onChange={(event) => this.changePatternDescriptionText(event)}
                style={{ whiteSpace: "pre-line", width: "100%" }}
              />
              <br />
              <br />
            </div>
          </div>
        );

        var patternMaintenanceTable = (
          <div>
            {searchBox}

            <div style={{ height: "60vh" }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={filteredData.length}
                    rowClassName={this._rowClassName}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowClick={this._onRowClick}
                    rowGetter={({ index }) => filteredData[index]}
                  >
                    <Column
                      width={width * 0.25}
                      label="Pattern#"
                      dataKey="id"
                    />
                    <Column
                      width={width * 0.75}
                      label="Pattern Description"
                      dataKey="restrictionPatternDescription"
                      cellRenderer={this.formatValue}
                    />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </div>
        );
        content = (
          <ContentBox style={{ overflow: "scroll", height: "100%" }}>
            <table border={1} width={"100%"}>
              <tr>
                <td width="80%"></td>
                <td width="20%">
                  {this.state.isCreate ? updateButton : addButton}
                  {this.state.isCreate ? cancel : null}
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  {this.state.isCreate ? createEdit : patternMaintenanceTable}
                </td>
              </tr>
            </table>
          </ContentBox>
        );
      }
    }

    return (
      <div className="positionUnderHeader" style={{ height: "100%" }}>
        {content}
        {errorMsg}
      </div>
    );
  }
}

export const PatternMaintenance = withRouter(PatternMaintenanceComponent);

function sortAndReturnPatternTexts(patternTexts) {
  return patternTexts.sort(sortFunction).map((p) => p.lineText);
}

function sortFunction(c1, c2) {
  if (c1.seqNo < c2.seqNo) {
    return -1;
  }
  if (c1.seqNo > c2.seqNo) {
    return 1;
  }

  return 0;
}

function renderDataWithPopover(pattDesc, pattLineTexts) {
  if (pattDesc.length > 1) {
    const popOverBody = sortAndReturnPatternTexts(pattLineTexts);
    const popover = (
      <Popover id="popover-basic" title={pattDesc}>
        <table>
          <tbody>
            {popOverBody.map((val, i) => (
              <tr key={i}>
                <td id="formCText">{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Popover>
    );

    return (
      <OverlayTrigger placement="right" overlay={popover}>
        <span>{pattDesc}</span>
      </OverlayTrigger>
    );
  }
}

function chunkText(str, length) {
  return str.replace(
    new RegExp(`(?![^\\n]{1,${length}}$)([^\\n]{1,${length}})\\s`, "g"),
    "$1\n"
  );
}
